import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  enableLogs: true,
  sendDefaultPii: true,
  tracesSampleRate: 0.2,
  replaysSessionSampleRate: Number(
    import.meta.env.VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE ?? 0
  ),
  replaysOnErrorSampleRate: Number(
    import.meta.env.VITE_SENTRY_REPLAYS_ONERROR_SAMPLE_RATE ?? 0
  ),
});

const rootElement = document.getElementById("root");
if (!rootElement) {
  Sentry.captureException(new Error("Root element not found"));
  throw new Error("Root element #root not found in index.html");
}

// eslint-disable-next-line import/no-named-as-default-member
ReactDOM.createRoot(rootElement || document.createElement("div")).render(
  <React.StrictMode>
    <Sentry.ErrorBoundary
      onError={(error) => Sentry.captureException(error)}
      fallback={<p>Oops! Something went wrong.</p>}
    >
      <App />
    </Sentry.ErrorBoundary>
  </React.StrictMode>
);
